export const userRoles = [
  {
    id: 1,
    name: "Prasun Singh",
    email: "prasun@goldenflitch.com",
    role: "Owner",
  },
  {
    id: 2,
    name: "Sidhant Chandel",
    email: "sidhant@goldenflitch.com",
    role: "Editor",
  },
  {
    id: 3,
    name: "Amrit Sonar",
    email: "amrit@goldenflitch.com",
    role: "Viewer",
  },
];
